export const LINK_HOME = "/"
export const LINK_ABOUT = "/qui-sommes-nous"
export const LINK_PORTFOLIO = "/portfolio"
export const LINK_TEAMS = "/our-team"
export const LINK_CONTACT = "/contact-us"
export const LINK_CAREER = "/nous-recrutons"
export const LINK_BECOME_PARTNER = "/devenir-partenaire"
export const LINK_SERVICE = "/services"
export const LINK_TERMS = "/terms-conditions"
// export const LINK_POLICY = "/politique-de-confidentialite"
